var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrighter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "400px",
    height: "160px",
    viewBox: "0 0 400 160",
    enableBackground: "new 0 0 400 160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#22356C",
    d: "M47.385,102.554H13.68V41.983c0-7.464,2.86-14.551,8.084-19.651c5.349-5.348,12.562-8.209,20.273-8.209 c16.417,0,28.357,10.447,28.357,25.497c0,7.339-3.109,13.06-7.586,16.79c7.338,3.857,11.566,10.945,11.566,20.772 C74.375,92.604,64.053,102.554,47.385,102.554z M30.098,49.944H43.78c0.995,0,10.073-0.25,10.073-9.578 c0-7.213-5.596-10.199-11.815-10.199c-6.964,0-11.94,5.224-11.94,11.816V49.944z M44.65,65.242H30.098v22.014h14.8 c6.467,0,12.562-2.362,12.562-10.821C57.46,69.221,52.858,65.242,44.65,65.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22356C",
    d: "M111.44,52.679c-10.448-1.865-17.413,3.73-17.413,12.811v37.064H77.61V65.489 c0-18.158,12.562-30.845,33.83-28.232V52.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA71B",
    d: "M115.671,31.535v-9.203c0-4.603,3.73-8.209,8.333-8.209c4.477,0,8.208,3.607,8.208,8.209v9.203H115.671z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.796,
    y: 38.5,
    fill: "#22356C",
    width: 16.417,
    height: 64.054
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22356C",
    d: "M185.073,112.077V96.706c-4.852,4.729-11.443,7.217-18.658,7.217c-16.915,0-30.72-14.925-30.72-33.334 c0-18.532,13.557-33.706,32.959-33.706c19.278,0,32.834,15.174,32.834,33.706v41.481 M168.655,52.306 c-9.08,0-16.418,7.836-16.418,18.407c0,10.2,7.339,18.033,16.418,18.033c9.079,0,16.418-8.082,16.418-18.033 C185.073,60.514,177.733,52.306,168.655,52.306z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22356C",
    d: "M262.31,102.554h-16.415V65.117c0-3.731-1.245-12.189-11.941-12.189c-7.339,0-12.437,4.975-12.437,12.189 v37.437h-16.541V10.019h16.541v31.839c4.103-3.109,9.079-4.975,14.675-4.975c15.672,0,26.118,11.318,26.118,28.233V102.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22356C",
    d: "M294.665,102.427c-18.78,1.994-28.731-9.326-28.731-26.862V22.208h16.418V38.5h11.566v14.553h-11.566 v22.636c0,8.955,4.104,12.313,12.313,11.816V102.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22356C",
    d: "M358.345,82.155c-3.73,13.061-15.048,21.891-30.969,21.891c-18.159,0-32.835-14.926-32.835-33.457 c0-18.532,14.676-33.706,32.835-33.706c15.422,0,28.356,9.701,31.467,26.865L313.57,82.779c3.233,4.352,8.086,6.838,13.683,6.838 c5.348,0,10.818-2.361,13.555-7.462H358.345z M339.938,57.033c-2.985-3.608-7.462-5.721-12.685-5.721 c-9.454,0-17.042,7.461-17.414,18.406L339.938,57.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22356C",
    d: "M394.928,52.679c-10.447-1.865-17.412,3.73-17.412,12.811v37.064h-16.417V65.489 c0-18.158,12.562-30.845,33.829-28.232V52.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAA71B",
    d: "M185.174,114.149c0,0-3.702,19-25.541,19c-21.837,0-25.591-19-25.591-19h-16.264 c0,0,5.823,33.922,41.929,33.922c36.105,0,41.783-33.922,41.783-33.922H185.174z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrighter);
export default __webpack_public_path__ + "static/media/brighter.191f08946102625fcfdb53c53f819800.svg";
export { ForwardRef as ReactComponent };